import $apiJSON from 'http/apiJSON'

const BASE = '/plagiarism'

export const listChecks = (params = {}) =>
  $apiJSON.get(`${BASE}/checks/`, { params })

export const getCheck = (id) => $apiJSON.get(`${BASE}/checks/${id}/`)

export const runCheck = (checkId) =>
  $apiJSON.post(`${BASE}/checks/run/${checkId}/`, {})

export const createCheck = (payload) =>
  $apiJSON.post(`${BASE}/check/`, payload)

export default {
  listChecks,
  getCheck,
  runCheck,
  createCheck,
}
